import React, { useEffect, useState, useRef } from "react";
import LeafletMap from "../components/LeafletMap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays, setHours, setMinutes, isSameDay } from "date-fns";
// GraphHopper API key - you should move this to an environment variable
const GRAPHHOPPER_API_KEY = process.env.REACT_APP_GRAPHHOPPER_API_KEY;



const getAddressFromCoordinates = async (lat, lng) => {
  
  try {
    const response = await fetch(`https://graphhopper.com/api/1/geocode?point=${lat},${lng}&reverse=true&country=CL&key=${GRAPHHOPPER_API_KEY}`);
    const data = await response.json();
    if (data.hits && data.hits.length > 0) {
      return data.hits[0].name + ", " + (data.hits[0].city || data.hits[0].state || '');
    }
    return null;
  } catch (error) {
    console.error("Error al obtener la dirección:", error);
    return null;
  }
};

// Nueva función: obtener coordenadas desde dirección
const getCoordinatesFromAddress = async (address) => {
  try {
    const response = await fetch(`https://graphhopper.com/api/1/geocode?q=${encodeURIComponent(address)}&limit=1&country=CL&key=${GRAPHHOPPER_API_KEY}`);
    const data = await response.json();
    if (data.hits && data.hits.length > 0) {
      return {
        lat: data.hits[0].point.lat,
        lng: data.hits[0].point.lng,
        displayName: data.hits[0].name + (data.hits[0].city ? ', ' + data.hits[0].city : '')
      };
    }
    return null;
  } catch (error) {
    console.error("Error al obtener coordenadas:", error);
    return null;
  }
};

const containerStyle = {
  height: "500px",
  width: "100%",
  borderRadius: "12px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

const styles = {
  div:{
    marginBottom:"10px"
  },
  mainContainer: {
    backgroundColor: "#ffffffff",
    minHeight: "100vh",
    padding: "2rem",

  },
  contentContainer: {
    maxWidth: "1200px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "2rem",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  title: {
    color: "#8B0000",
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    textAlign: "center",
  },
  inputContainer: {
    marginBottom: "1.5rem",
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    border: "2px solid #e0e0e0",
    borderRadius: "8px",
    fontSize: "1rem",
    transition: "all 0.3s ease",
    "&:focus": {
      borderColor: "#8B0000",
      outline: "none",
      boxShadow: "0 0 0 3px rgba(139, 0, 0, 0.1)",
    },
  },
  label: {
    display: "block",
    marginBottom: "0.5rem",
    color: "#4a4a4a",
    fontWeight: "500",
  },
  button: {
    backgroundColor: "#8B0000",
    color: "#ffffff",
    padding: "12px 24px",
    borderRadius: "8px",
    border: "none",
    fontSize: "1rem",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    width: "100%",
    marginTop: "1rem",
    "&:hover": {
      backgroundColor: "#6B0000",
      transform: "translateY(-1px)",
    },
  },
  clearButton: {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    padding: "12px 24px",
    borderRadius: "8px",
    border: "none",
    fontSize: "1rem",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    width: "100%",
    marginTop: "1rem",
    "&:hover": {
      backgroundColor: "#5a6268",
      transform: "translateY(-1px)",
    },
  },
  distanceContainer: {
    backgroundColor: "#ffffffff",
    padding: "1rem",
    borderRadius: "8px",
    marginTop: "1rem",
    textAlign: "center",
  },
  distanceText: {
    color: "#4a4a4a",
    fontSize: "1.1rem",
    marginBottom: "0.5rem",
  },
  priceText: {
    color: "#8B0000",
    fontSize: "1.5rem",
    fontWeight: "600",
  },
};
const user = JSON.parse(localStorage.getItem('datosUsuario'));
const MapComponent = () => {
  const [step, setStep] = useState(1);
  const [markers, setMarkers] = useState([]);
  const [directions, setDirections] = useState(null);
  const [distance, setDistance] = useState(null);
  const [inicio, setInicio] = useState('');
  const [termino, setTermino] = useState('');
  const [isCalculating, setIsCalculating] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  // Autocomplete y loader
  const [inicioSuggestions, setInicioSuggestions] = useState([]);
  const [terminoSuggestions, setTerminoSuggestions] = useState([]);
  const [loadingInicio, setLoadingInicio] = useState(false);
  const [loadingTermino, setLoadingTermino] = useState(false);
  const [inicioTimer, setInicioTimer] = useState(null);
  const [terminoTimer, setTerminoTimer] = useState(null);
  const [isLocked, setIsLocked] = useState(false);
  const [embalaje, setEmbalaje] = useState('nada');
  const [fecha, setFecha] = useState(null);
  const [hora, setHora] = useState(null);
  
  let precio = 0
  // Restaurar useEffect para recalcular ruta automáticamente
  useEffect(() => {
    if (markers.length === 2 && !isCalculating) {
      calculateRoute();
    }
  }, [markers]);

  useEffect(() => {
    if (markers.length === 2) {
      setIsLocked(true);
    } else {
      setIsLocked(false);
    }
  }, [markers.length]);

  const calculateRoute = async () => {
    if (markers.length !== 2) return;
    console.log(markers)
    setIsCalculating(true);
    try {
      const response = await fetch(
        `https://graphhopper.com/api/1/route?` + 
        `point=${markers[0].lat},${markers[0].lng}&` +
        `point=${markers[1].lat},${markers[1].lng}&` +
        `vehicle=car&` +
        `points_encoded=false&` + // Request unencoded points
        `key=${GRAPHHOPPER_API_KEY}`
      );
      console.log("seteada ruta")
      const data = await response.json();

      if (data.paths && data.paths.length > 0) {
        console.log("ruta correcta")
        const path = data.paths[0];
        setDirections(data);
        setDistance(path.distance / 1000); // Convert to kilometers

        // Update address inputs
        const startAddress = await getAddressFromCoordinates(markers[0].lat, markers[0].lng);
        const endAddress = await getAddressFromCoordinates(markers[1].lat, markers[1].lng);
        if (startAddress) setInicio(startAddress);
        if (endAddress) setTermino(endAddress);
      } else {
        console.error("No route found");
        alert("No se pudo encontrar una ruta entre los puntos seleccionados");
      }
    } catch (error) {
      console.error("Error calculating route:", error);
      alert("Error al calcular la ruta");
    } finally {
      setIsCalculating(false);
    }
  };

  const handleMapClick = (event) => {
    if (markers.length < 2) {
      const newMarker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      setMarkers(prev => [...prev, newMarker]);
    }
  };

  const calculatePrice = (distanceInKm) => {
    if (distanceInKm <= 150) {
      return 150000;
    } else {
      return 150000 + Math.round((distanceInKm - 150) * 1500);
    }
  };
  
  const cotizar = async () => {
  if (markers.length < 2) {
    alert('Por favor, selecciona dos puntos en el mapa.');
    return;
  }

  const user = JSON.parse(localStorage.getItem('datosUsuario'));
  if (!user || !user.mail) {
    alert('Debes iniciar sesión para realizar una cotización. Por favor, inicia sesión e intenta nuevamente.');
    return;
  }

  let precioBase = calculatePrice(distance);
  let precioTotal = precioBase;

  if (embalaje === 'medio') {
    precioTotal += 50000;
  } else if (embalaje === 'premium') {
    precioTotal += 100000;
  }

  // Solo para mostrar en la UI
  const precioFormateado = precioTotal.toLocaleString();

  const inicioDireccion = await getAddressFromCoordinates(markers[0].lat, markers[0].lng);
  const terminoDireccion = await getAddressFromCoordinates(markers[1].lat, markers[1].lng);

  if (!inicioDireccion || !terminoDireccion) {
    alert('Hubo un error al obtener las direcciones.');
    return;
  }

  const datos = {
    inicio: inicioDireccion,
    termino: terminoDireccion,
    mail: user.mail,
    fecha: fecha,
    hora: hora,
    embalaje: embalaje,
    precio: precioTotal, // Se envía como número entero sin formato
    estado: 'no pagado',
    telefono: user.telefono,
    rut: user.rut,
    nombre: user.nombre
  };

  console.log("Precio para mostrar:", precioFormateado);
  console.log("Precio enviado al backend:", datos.precio);

  try {
    const response = await fetch('https://frabas.cl/backend/envios.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(datos),
    });

    const resultado = await response.json();
    if (resultado.success) {
      alert(`Cotización enviada correctamente. Precio: $${precioFormateado}`);
    } else {
      alert('Error al enviar la cotización');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Ocurrió un error al enviar la cotización');
  }
};


  const vaciar = () => {
    setMarkers([]);
    setDirections(null);
    setDistance(null);
    setInicio('');
    setTermino('');
    setIsCalculating(false);
    setIsLocked(false);
  };

  // Autocomplete para inputs
  const fetchAddressSuggestions = async (value, setSuggestions, setLoading) => {
    if (!value.trim()) {
      setSuggestions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`https://graphhopper.com/api/1/geocode?q=${encodeURIComponent(value)}&limit=5&country=CL&key=${GRAPHHOPPER_API_KEY}`);
      const data = await response.json();
      if (data.hits) {
        setSuggestions(data.hits.map(hit => ({
          label: hit.name + (hit.city ? ', ' + hit.city : ''),
          lat: hit.point.lat,
          lng: hit.point.lng
        })));
      } else {
        setSuggestions([]);
      }
    } catch (e) {
      setSuggestions([]);
    }
    setLoading(false);
  };

  // Handlers para inputs de dirección con autocompletado y loader
  const handleInicioInput = (e) => {
    if (isLocked) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      e.target.blur(); // Quitar el foco del input
      return;
    }
    const value = e.target.value;
    setInicio(value);
    setInicioSuggestions([]);
    if (inicioTimer) clearTimeout(inicioTimer);
    setInicioTimer(setTimeout(() => {
      fetchAddressSuggestions(value, setInicioSuggestions, setLoadingInicio);
    }, 400));
  };

  const handleTerminoInput = (e) => {
    if (isLocked) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      e.target.blur(); // Quitar el foco del input
      return;
    }
    const value = e.target.value;
    setTermino(value);
    setTerminoSuggestions([]);
    if (terminoTimer) clearTimeout(terminoTimer);
    setTerminoTimer(setTimeout(() => {
      fetchAddressSuggestions(value, setTerminoSuggestions, setLoadingTermino);
    }, 400));
  };

  // Buscar dirección al presionar Enter o perder foco
  const handleInicioBlurOrEnter = async (value) => {
    if (markers.length === 2) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      return;
    }
    if (!value.trim()) return;
    setLoadingInicio(true);
    const coords = await getCoordinatesFromAddress(value);
    setLoadingInicio(false);
    if (coords) {
      if (markers.length === 2) {
        setMarkers([ { lat: coords.lat, lng: coords.lng }, markers[1] ]);
      } else if (markers.length === 1) {
        setMarkers([ { lat: coords.lat, lng: coords.lng } ]);
      } else {
        setMarkers([ { lat: coords.lat, lng: coords.lng } ]);
      }
      setInicio(coords.displayName);
    } else {
      alert('No se encontró la dirección de inicio.');
    }
  };

  const handleTerminoBlurOrEnter = async (value) => {
    if (markers.length === 2) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      return;
    }
    if (!value.trim()) return;
    setLoadingTermino(true);
    const coords = await getCoordinatesFromAddress(value);
    setLoadingTermino(false);
    if (coords) {
      if (markers.length === 2) {
        setMarkers([ markers[0], { lat: coords.lat, lng: coords.lng } ]);
      } else if (markers.length === 1) {
        setMarkers([ markers[0], { lat: coords.lat, lng: coords.lng } ]);
      } else {
        setMarkers([ { lat: coords.lat, lng: coords.lng } ]);
      }
      setTermino(coords.displayName);
    } else {
      alert('No se encontró la dirección de término.');
    }
  };

  // Selección de sugerencia
  const selectInicioSuggestion = (suggestion) => {
    if (markers.length === 2) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      return;
    }
    setInicio(suggestion.label);
    setInicioSuggestions([]);
    if (markers.length === 2) {
      setMarkers([ { lat: suggestion.lat, lng: suggestion.lng }, markers[1] ]);
    } else if (markers.length === 1) {
      setMarkers([ { lat: suggestion.lat, lng: suggestion.lng } ]);
    } else {
      setMarkers([ { lat: suggestion.lat, lng: suggestion.lng } ]);
    }
  };
  const selectTerminoSuggestion = (suggestion) => {
    if (markers.length === 2) {
      alert('Debes vaciar los puntos antes de elegir nuevas direcciones.');
      return;
    }
    setTermino(suggestion.label);
    setTerminoSuggestions([]);
    if (markers.length === 2) {
      setMarkers([ markers[0], { lat: suggestion.lat, lng: suggestion.lng } ]);
    } else if (markers.length === 1) {
      setMarkers([ markers[0], { lat: suggestion.lat, lng: suggestion.lng } ]);
    } else {
      setMarkers([ { lat: suggestion.lat, lng: suggestion.lng } ]);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <div style={styles.contentContainer}>
        <h1 style={styles.title}>Cotización de Servicio</h1>

        {/* Paso 1: Embalaje */}
        {step === 1 && (
          <div style={styles.inputContainer}>
            <label style={styles.label} htmlFor="embalaje">¿Qué tipo de embalaje necesitas?</label>
            <select
              name="tipo_embalaje"
              id="embalaje"
              onChange={e => setEmbalaje(e.target.value)}
              style={{
                ...styles.input,
                backgroundColor: 'white',
                cursor: 'pointer'
              }}
              value={embalaje}
            >
              <option value="nada">Seleccione un embalaje</option>
              <option value="basico">Básico Gratis</option>
              <option value="medio">Medio desde $50.000</option>
              <option value="premium">Premium desde $100.000</option>
            </select>
            <button
              style={styles.button}
              onClick={() => {
                if (embalaje === "nada") {
                  alert("Por favor selecciona un tipo de embalaje.");
                  return;
                }
                setStep(2);
              }}
            >
              Siguiente
            </button>
          </div>
        )}

        {/* Paso 2: Fecha y Hora */}
        {step === 2 && (
    <div style={styles.inputContainer}>
      <label style={styles.label}>¿Para qué fecha necesitas el servicio?</label>
      <DatePicker
        selected={fecha}
        onChange={date => setFecha(date)}
        minDate={addDays(new Date(), 1)}
        maxDate={addDays(new Date(), 7)}
        placeholderText="Selecciona una fecha"
        dateFormat="dd/MM/yyyy"
        className="w-full p-3 border-2 border-gray-200 rounded-lg text-base"
        calendarStartDay={1}
        withPortal
      />
      <label style={styles.label} className="mt-4">¿A qué hora?</label>
      <DatePicker
        selected={hora}
        onChange={date => setHora(date)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={30}
        timeCaption="Hora"
        dateFormat="HH:mm"
        placeholderText="Selecciona una hora"
        className="w-full p-3 border-2 border-gray-200 rounded-lg text-base"
        minTime={setHours(setMinutes(new Date(), 0), 8)}
        maxTime={setHours(setMinutes(new Date(), 0), 20)}
        disabled={!fecha}
        withPortal
      />
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <button
          style={styles.clearButton}
          onClick={() => setStep(1)}
        >
          Atrás
        </button>
        <button
          style={styles.button}
          onClick={() => {
            if (!fecha || !hora) {
              alert("Por favor selecciona fecha y hora.");
              return;
            }
            setStep(3);
          }}
        >
          Siguiente
        </button>
      </div>
    </div>
  )}

        {/* Paso 3: Direcciones y Mapa */}
        {step === 3 && (
          <>
            
            <div style={styles.inputContainer}>
              <label style={styles.label} htmlFor="inicio">Dirección de inicio</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  id="inicio"
                  value={inicio}
                  onChange={handleInicioInput}
                  onBlur={() => handleInicioBlurOrEnter(inicio)}
                  onKeyDown={e => { if (e.key === 'Enter') { handleInicioBlurOrEnter(inicio); e.target.blur(); }}}
                  placeholder="Ej: Av. Moneda 123"
                  style={{
                    ...styles.input,
                    backgroundColor: isLocked ? '#f5f5f5' : 'white',
                    cursor: isLocked ? 'not-allowed' : 'text'
                  }}
                  disabled={isLocked}
                  autoComplete="off"
                />
                {loadingInicio && <div style={{position:'absolute',right:10,top:12}}><span className="loader" style={{width:16,height:16,border:'2px solid #8B0000',borderTop:'2px solid transparent',borderRadius:'50%',display:'inline-block',animation:'spin 1s linear infinite'}}></span></div>}
                {!isLocked && inicioSuggestions.length > 0 && (
                  <ul style={{position:'absolute',zIndex:10,background:'#fff',width:'100%',border:'1px solid #ccc',borderRadius:4,margin:0,padding:0,listStyle:'none',maxHeight:150,overflowY:'auto'}}>
                    {inicioSuggestions.map((s,i) => (
                      <li key={i} style={{padding:'8px',cursor:'pointer'}} onMouseDown={() => selectInicioSuggestion(s)}>{s.label}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div style={styles.inputContainer}>
              <label style={styles.label} htmlFor="termino">Dirección de término</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  id="termino"
                  value={termino}
                  onChange={handleTerminoInput}
                  onBlur={() => handleTerminoBlurOrEnter(termino)}
                  onKeyDown={e => { if (e.key === 'Enter') { handleTerminoBlurOrEnter(termino); e.target.blur(); }}}
                  placeholder="Ej: Av. Dolar 124"
                  style={{
                    ...styles.input,
                    backgroundColor: isLocked ? '#f5f5f5' : 'white',
                    cursor: isLocked ? 'not-allowed' : 'text'
                  }}
                  disabled={isLocked}
                  autoComplete="off"
                />
                {loadingTermino && <div style={{position:'absolute',right:10,top:12}}><span className="loader" style={{width:16,height:16,border:'2px solid #8B0000',borderTop:'2px solid transparent',borderRadius:'50%',display:'inline-block',animation:'spin 1s linear infinite'}}></span></div>}
                {!isLocked && terminoSuggestions.length > 0 && (
                  <ul style={{position:'absolute',zIndex:10,background:'#fff',width:'100%',border:'1px solid #ccc',borderRadius:4,margin:0,padding:0,listStyle:'none',maxHeight:150,overflowY:'auto'}}>
                    {terminoSuggestions.map((s,i) => (
                      <li key={i} style={{padding:'8px',cursor:'pointer'}} onMouseDown={() => selectTerminoSuggestion(s)}>{s.label}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <button onClick={vaciar} style={{
              ...styles.clearButton,
              backgroundColor: isLocked ? '#8B0000' : '#6c757d',
              animation: isLocked ? 'pulse 2s infinite' : 'none'
            }}>
              Vaciar puntos
            </button>
            <LeafletMap 
              markers={markers}
              onMapClick={handleMapClick}
              directions={directions}
            />
            {distance && (
              <div style={styles.distanceContainer}>
                <p style={styles.distanceText}>
                  Distancia: {distance.toFixed(2)} km
                </p>
                <p style={styles.priceText}>
                  Precio estimado: ${calculatePrice(distance).toLocaleString()} CLP
                </p>
              </div>
            )}
            <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
              <button
                style={styles.clearButton}
                onClick={() => setStep(2)}
              >
                Atrás
              </button>
              <button
                onClick={cotizar}
                style={styles.button}
              >
                Cotizar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MapComponent;
